import React, { Component } from 'react';
import { axiosInstance } from '../../utils/axiosInstance';

import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import store from '../../store';
import { Add } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ImageUploader from 'react-images-upload';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormHelperText from '@material-ui/core/FormHelperText';
import {  Edit, Delete } from '@material-ui/icons';
import swal from 'sweetalert'



export class ProductForm extends Component {

    constructor(props) {
        super(props);

        this.state = {

            productCategories: [],


        
            productID: this.props.match.params.value,

            productCategoryID: '',
            name: '',
            url:'',
            activeIngredient: '',
            shortDescription:'',

            group: '',
            presentation: '',
            enabled: false,
            lastRelease: false,
            tax: '',
            articuloEmpresa: '',
            articuloID: '',
            descriptions: [],
            images:[],

            isEdit: this.props.match.params.value != undefined,
            tabValue: '0',

            //image modal
            
            form: new FormData(),
            isImageEdit:false,
            modalTitle: '',
            imageID: '',
            imageOrder: '',
            image: '',
            warningImageText: '',

            stock: '',


        };

        this.onDropImage = this.onDropImage.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.onSubmitModal = this.onSubmitModal.bind(this);   

        this.handleNewImageClick = this.handleNewImageClick.bind(this);
        this.handleEditImageClick = this.handleEditImageClick.bind(this);   
        this.handleDeleteImageClick = this.handleDeleteImageClick.bind(this);   
        this.getImages = this.getImages.bind(this);   
        
    }

    CreateStyles() {
        return {
            //marginRight: '10px',
            //marginBottom: '10px',
            float: 'right'
        }
    }

    async executeRESTCall(action) {

        let formData = {

            productID: this.state.productID,
            productCategoryID: this.state.productCategoryID,
            name: this.state.name,
            url: this.state.url,
            activeIngredient: this.state.activeIngredient,
            shortDescription: this.state.shortDescription,                        
            productBrandID: this.state.productBrandID,
            
        
            group: this.state.group,
            tax: this.state.tax,

            presentation: this.state.presentation,
            enabled: this.state.enabled,
            lastRelease: this.state.lastRelease,
            articuloEmpresa: this.state.articuloEmpresa,
            articuloID: this.state.articuloID,

            descriptions: this.state.descriptions,
            stock: this.state.stock



        };

        if (action === "POST") {
            await axiosInstance.post('/api/Product/', formData)
                .then(response => {

                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: "Operación exitosa"
                    })


                    this.setState({
                        isEdit: true,
                        productID: response.data,
					})


                }).catch(error => {
                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: error.response.data.message
                    })
                });
        }

        if (action === "PUT") {
            await axiosInstance.put('/api/Product/', formData)
                .then(response => {

                    this.props.history.push('/productos');
                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: "Operación exitosa"
                    })

                }).catch(error => {
                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: error.response.data.message
                    })
                });
        }     

     

      
  

    }   

    onSubmit = e => {

        if (!this.state.isEdit) {
            this.executeRESTCall("POST");
        }
        else {
            this.executeRESTCall("PUT");
        }
    
        e.preventDefault();
    }

    onChange = (event, value) => {

        if (event.target.type === "checkbox") {
            this.setState({
                [event.target.name]: event.target.checked,
            })
        }
        else {
            if (event.target.name === "name") {
                var str = event.target.value;
                str = str.replace(/\s+/g, '-').toLowerCase();

                this.setState({
                    [event.target.name]: event.target.value,
                    url: str,
                })
            }


            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }      

    handleTabChange = (event, newValue) => {

        this.setState({
            tabValue: newValue,
        })
    };

    handleChange(e, index) {


        let descriptions = [...this.state.descriptions];

        let description = { ...descriptions[index] };

        if (e.target.name == 'description') {
            description.description = e.target.value;
        }

        if (e.target.name == 'language') {
            description.languageID = e.target.value;
        }


        descriptions[index] = description;

        this.setState({ descriptions });

    }

    renderOptions() {
        return this.state.productCategories.map((dt, i) => {            
            return (
                <MenuItem
                    label="Seleccione una categoría"
                    value={dt.id}
                    key={i} name={dt.text}>{dt.text}
                </MenuItem>
            );
        });
    }





    renderCategoryOptions() {
        return this.state.productCategories.map((dt, i) => {
            return (

             
                <MenuItem
                    label="Seleccione una familia"
                    value={dt.id}
                    key={i} name={dt.text}>{dt.text}
                    </MenuItem>
            
            );
        });
    }

    async componentDidMount() {       


        const productCategoryResponse = await axiosInstance.get(`/api/ProductCategory/GetproductCategoryForSelect`);               

        this.setState({
            productCategories: productCategoryResponse.data,

        });

        if (this.state.isEdit) {

            await axiosInstance.get(`api/Product/GetByID/${this.state.productID}`).then(
                response => {
                    this.setState({
                        productID: response.data.productID,
                        productCategoryID: response.data.productCategoryID,
                        name: response.data.name,
                        url: response.data.url,
                        activeIngredient: response.data.activeIngredient,
                        shortDescription: response.data.shortDescription,
                     
                        group: response.data.group,
                        tax: response.data.tax,
                        presentation: response.data.presentation,
                        lastRelease: response.data.lastRelease,
                        enabled: response.data.enabled,
                        descriptions: response.data.descriptions,
                        images: response.data.images,
                        articuloEmpresa: response.data.articuloEmpresa,
                        articuloID: response.data.articuloID,
                        stock: response.data.stock
                    });
                });         
        }        
    }

    async getImages() {
        await axiosInstance.get(`api/Product/GetByID/${this.state.productID}`).then(
            response => {
                this.setState({        
                    images: response.data.images, 

                });
            });         
    }


  
  

    renderHeaderTitle() {
        let title;

        if (this.state.isEdit) {
            title = 'Editando producto ' + this.state.name ;
        }
        else {
            title = 'Crea un nuevo producto';
        }

        return (
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <h4>
                            {title}
                            <small >
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Typography color="inherit">
                                        Productos
                                        </Typography>

                                    <Link color="inherit" to="/Productes" >
                                        <Typography color="textPrimary">Administración</Typography>
                                    </Link>

                                </Breadcrumbs>
                            </small>
                        </h4>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Link to="/Productos">
                            <Button                      
                                color="default"
                                size="small"
                                startIcon={<CancelIcon />}
                                style={this.CreateStyles()}
                            >
                                Cancelar
                        </Button>
                        </Link>
                    </Grid>
                </Grid>

                <hr />
            </div>
        );
    }

    

    
    renderGeneralInformation() {


        if (this.state.tabValue == '0') {
            return (
                <Paper square style={{ padding: "15px" }}>
                    <ValidatorForm ref="form"
                        onSubmit={this.onSubmit}
                        onError={errors => console.log(errors)}
                        >

                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={12} md={5}>

                                <Grid container spacing={2} >
                                    <Grid item sm={12} xs={12}>
                                        <TextValidator id="Name"
                                            style={{
                                                width: "100%"

                                            }}
                                            name="name"
                                            label="Nombre"
                                            variant="outlined"
                                            size="small"
                                            onChange={this.onChange}
                                            value={this.state.name}
                                            validators={['required', 'maxStringLength:80']}
                                            errorMessages={['El nombre del producto es requerido', 'Máximo 80 carácteres']}
                                            autoFocus
                                            autoComplete="off"

                                        />

                                        <p style={{color:'#666', marginTop:'8px'}}>
                                            {"Tipee <br /> si desea realizar un 'salto de linea'"}
                                            </p>

                                    </Grid>


                                        <Grid item sm={12} xs={12}>

                                            <TextValidator id="url"
                                                style={{
                                                    width: "100%"
                                                }}
                                                name="url"
                                                label="Url"
                                                variant="outlined"
                                                size="small"
                                                onChange={this.onChange}
                                                value={this.state.url}
                                                validators={[
                                                    'required'
                                                    , 'matchRegexp:^[a-zA-Z\-0-9]+$'
                                                ]}
                                                errorMessages={['El url es requerido', 'Carácteres no válidos (& / ? . , _)']}
                                                autoComplete="off"
                                            />

                                        </Grid>

                                    <Grid item sm={12} xs={12}>

                                        <TextValidator id="activeIngredient"
                                            style={{
                                                width: "100%"
                                            }}
                                            name="activeIngredient"
                                            label="Principio activo"
                                            variant="outlined"
                                            size="small"
                                            onChange={this.onChange}
                                            value={this.state.activeIngredient}
                                            validators={['required', 'maxStringLength:380']}
                                            errorMessages={['El principio activo es requerido', 'Máximo 380 carácteres']}
                                            autoComplete="off"
                                        />

                                    </Grid>


                                   

                                    <Grid item sm={12} xs={12}>
                                        <TextValidator id="shortDescription"
                                            style={{
                                                width: "100%"

                                            }}
                                            name="shortDescription"
                                            label="Detalle"
                                            variant="outlined"
                                            size="small"
                                            onChange={this.onChange}
                                            value={this.state.shortDescription}
                                            validators={['required', 'maxStringLength:240']}
                                            errorMessages={['La descripción corta es requerida', 'Máximo 240 carácteres']}
                                            autoComplete="off"

                                        />
                                    </Grid>


                               

                                  

                                    <Grid item sm={12} xs={12}>

                                        <div className="padd50">
                                            <SelectValidator
                                                style={{ width: "100%" }}
                                                name="productCategoryID"
                                                variant="outlined"
                                                size="small"
                                                label="Familia"
                                                value={this.state.productCategoryID}
                                                validators={['required']}
                                                errorMessages={['La familia es requerida']}
                                                onChange={this.onChange}>
                                                {this.renderCategoryOptions()}

                                            </SelectValidator>
                                        </div>



                                    </Grid>                                                               

                            


                                    <Grid item sm={12} xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>

                                                <TextValidator id="group"
                                                    style={{ width: "100%" }}
                                                    name="group"
                                                    label="Grupo"
                                                    variant="outlined"
                                                    size="small"
                                                    onChange={this.onChange}
                                                    value={this.state.group}
                                                    autoComplete="off"
                                                    validators={['required', 'maxStringLength:5']}
                                                    errorMessages={['El grupo es requerido', 'Máximo 5 carácteres']}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextValidator id="tax"
                                                    style={{ width: "100%" }}
                                                    name="tax"
                                                    label="IVA"
                                                    variant="outlined"
                                                    size="small"
                                                    onChange={this.onChange}
                                                    value={this.state.tax}
                                                    autoComplete="off"
                                                    validators={['required', 'matchRegexp:^[0-9]+(\.[0-9]{1,2})?$']}
                                                    errorMessages={['El IVA es requerido', 'Solo números']}
                                                />
                                            </Grid>
                                   
                                        </Grid>


                                    </Grid>

                                    <Grid item sm={12} xs={12}>
                                        
                                             
                           
                                                <TextValidator id="presentation"
                                                    style={{ width: "100%" }}
                                                    name="presentation"
                                                    label="Presentación"
                                                    variant="outlined"
                                                    size="small"
                                                    onChange={this.onChange}
                                                    value={this.state.presentation}
                                                    autoComplete="off"
                                            validators={['required', 'maxStringLength:100']}
                                            errorMessages={['La presentación es requerida', 'Máximo 100 carácteres']}
                                                />
                                 


                                    </Grid>


                                    <Grid item sm={12} xs={12}>



                                        <TextValidator id="stock"
                                            style={{ width: "100%" }}
                                            name="stock"
                                            label="Stock"
                                            variant="outlined"
                                            size="small"
                                            onChange={this.onChange}
                                            value={this.state.stock}
                                            autoComplete="off"
                                            validators={['required', 'matchRegexp:^[0-9]+(\.[0-9]{1,2})?$']}
                                            errorMessages={['El stock es requerido', 'Solo números']}
                                        />



                                    </Grid>

                                    <Grid item sm={12} xs={12}>
                                    <h6 style={{ marginTop: '10px' }}>Plataforma</h6>
                                        </Grid>

                                    <Grid item sm={12} xs={12}>


                                            <TextValidator id="articuloEmpresa"
                                                style={{ width: "100%" }}
                                                name="articuloEmpresa"
                                                label="Artículo empresa plataforma"
                                                variant="outlined"
                                                size="small"
                                                onChange={this.onChange}
                                                value={this.state.articuloEmpresa}
                                                autoComplete="off"
                                                validators={['required', 'maxStringLength:50']}
                                                errorMessages={['El código de plataforma es requerido', 'Máximo 50 carácteres']}
                                            />
                                        


                                    </Grid>

                                    <Grid item sm={12} xs={12}>


                                        <TextValidator id="articuloEmpresa"
                                            style={{ width: "100%" }}
                                            name="articuloID"
                                            label="ArtículoID plataforma"
                                            variant="outlined"
                                            size="small"
                                            onChange={this.onChange}
                                            value={this.state.articuloID}
                                            autoComplete="off"
                                            validators={['required', 'matchRegexp:^[0-9]+(\.[0-9]{1,2})?$']}
                                            errorMessages={['El articuloID de plataforma es requerido', 'Solo números']}
                                        />



                                    </Grid>



                                    <Grid item sm={12} xs={12}>
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.enabled} onChange={this.onChange} name="enabled" />}
                                            label="Habilitado"
                                        />
                                    </Grid>


                                    <Grid item sm={12} xs={12}>
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.lastRelease} onChange={this.onChange} name="lastRelease" />}
                                            label="Novedad"
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={6}>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={<SaveIcon />}
                                            type="submit"

                                        >
                                            Guardar
                                    </Button>


                                    </Grid>

                                </Grid>

                            </Grid>

                            <Grid item xs={12} sm={12} md={7}>

                                <Grid container spacing={1}>
                                    <Grid item xs={6} sm={4} md={4} >
                                        <h6 style={{ marginTop: '10px'}}>Descripciones</h6>
                                    </Grid>
                                    <Grid item xs={6} sm={8} md={8}>
                                        <Button
                                            color="default"
                                            size="small"
                                            startIcon={<Add />}
                                            style={this.CreateStyles()}
                                            onClick={(e) => this.addDescription(e)}
                                        >
                                            Agregar
                                        </Button>
                                    </Grid> 
                                </Grid>

                                
                                <hr style={{marginTop:'0px'}}/>

                                {
                                    this.state.descriptions.map((description, index) => {

                                        return (
                                            <div key={index}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} md={2}>
                                                       
                                                    </Grid>

                                                    <Grid item xs={10} md={9}>

                                                        <TextValidator
                                                            style={{
                                                                width: "100%"
                                                            }}
                                                            name="description"
                                                            label="Descripción"
                                                            size="small"
                                                            onChange={(e) => this.handleChange(e, index)}
                                                            value={description.description}
                                                            validators={['required', 'maxStringLength:1500']}
                                                            errorMessages={['La descripción es requerida', 'Máximo 1500 carácteres']}
                                                            multiline
                                                            rows={7}
                                                            variant="outlined"

                                                        />
                                                    </Grid>
                                                    <Grid item xs={2} md={1}>
                                                      

                                                            <Tooltip title="Eliminar descripción">
                                                            <IconButton                                                                
                                                                onClick={(e) => this.removeDescription(index)}
                                                                color="secondary"
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                                            
                                                            </Tooltip>

                                                       
                                                    </Grid>

                                                </Grid>

                                                <hr />


                                                </div>


                                            )

                                    })
                                }

                               

                            </Grid>
                        </Grid>

                    </ValidatorForm>
                </Paper>
            );
        }
    }


    renderImageTab() {
        if (this.state.tabValue == '2') {
            return (
                <Paper square style={{ padding: "15px" }}>



                    <Button
                        color="default"
                        size="small"
                        startIcon={<Add />}
                        onClick={(e) => this.handleNewImageClick(e)}
                    >
                        Agregar imagén
                    </Button>

                    <br />
                    <br />

                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Imágen</TableCell>
                                    <TableCell align="left">Descripción</TableCell>
                                    <TableCell>Orden</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.images.map((img) => (
                                    <TableRow key={img.id}>
                                        <TableCell component="th" scope="row">
                                            <img src={img.url} style={{ width: '100px' }} />
                                        </TableCell>
                                        <TableCell align="left">{img.alternativeText}</TableCell>
                                        <TableCell> {img.order}</TableCell>
                                        <TableCell>
                                            <Tooltip title="Editar">
                                                <IconButton
                                                    aria-label="editar"
                                                    onClick={this.handleEditImageClick}
                                                    data-row_id={img.id}
                                                >
                                                    <Edit color="primary" />
                                                </IconButton>
                                            </Tooltip>

                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Eliminar">
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={this.handleDeleteImageClick}
                                                    data-row_id={img.id}
                                                >
                                                    <Delete color="secondary" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>



                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>);
        }
    }






    closeDialog() {
        this.setState({
            dialogOpen: false
        })
    }


  
 

   

    hideIfNewProduct() {
        if (this.state.isEdit)
            return { display: '' };
        else {
            return { display: 'none' };
        }
    }


    addDescription() {
        this.setState(
            { descriptions: [...this.state.descriptions, ""] }
        )
    }

    removeDescription(index) {
        let descriptions = [...this.state.descriptions];

        descriptions.splice(index, 1);

        this.setState({
            descriptions: descriptions
        });
    }



    onDropImage(pictureFiles, pictureDataURLs) {

        let form = this.state.form;
        var element = pictureFiles[0];

        form.append('image', element);

        this.setState({
            form: form,
            image: element === undefined ? '' : element.name,
        });

        if (this.state.documentFront !== '' && this.state.documentBack !== '') {
            this.setState({
                warningTextDocument: '',
            });
        }
    }

    addImage = async (image) => {

        this.setState({
            warningImageText: '',
        });

        var form = this.state.form;
        var validation = true;

        //form.append('imageOrder', this.state.imageOrder);
        form.append('productID', this.state.productID);
        //form.append('imageDescription', this.state.imageDescription);


        if (this.state.isImageEdit) {
            form.append('imageID', this.state.imageID);

            await axiosInstance.put('/api/Product/UpdateImage', form)
                .then(response => {

                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: "Operación exitosa"
                    })

                }).catch(error => {
                    store.dispatch({
                        type: "SNACKBAR_SUCCESS",
                        message: error.response.data.message
                    })
                });

            this.setState({
                dialogOpen: false,
            });

            await this.getImages();
        }
        else {
            if (this.state.image === '') {
                validation = false;
                this.setState({
                    warningImageText: "Las imagen es requerida"
                });
            }
            else {


                await axiosInstance.post('/api/Product/SaveImage', form)
                    .then(response => {

                        store.dispatch({
                            type: "SNACKBAR_SUCCESS",
                            message: "Operación exitosa"
                        })

                    }).catch(error => {
                        store.dispatch({
                            type: "SNACKBAR_SUCCESS",
                            message: error.response.data.message
                        })
                    });


                
                this.setState({
                    dialogOpen: false,
                });

                await this.getImages();
            }            
        }

     

    }


    async onSubmitModal(e) {
        e.preventDefault();
        await this.addImage(this.state.file);
    }


    async handleNewImageClick(e) {
        this.setState({
            isImageEdit: false,
            modalTitle: 'Nueva imagen',
            dialogOpen: true,

            form: new FormData(),
            imageID: '',
            imageOrder: '',
            imageDescription:'',
            image: '',
            defaultImage: '',
            warningImageText: '',
        })
    }

    async handleDeleteImageClick(e) {

        var id = e.currentTarget.dataset.row_id;

        const deleteRow = await swal({
            title: "¿Confirma la operación?",
            text: "",
            icon: "warning",
            dangerMode: true,
            buttons: true,

        });

        if (deleteRow) {



            await axiosInstance.delete('/api/product/deleteImage/' + id)
                .then(response => {

                    swal("Se eliminó el registro", {
                        icon: "success",
                    });
        
                }).catch(error => {

                    swal({
                        icon: 'error',
                        title: 'Oops, algo sucedió...',
                        text: error.response.data.message
                    })

                });


 
                await this.getImages();
        }
    }
    

    async handleEditImageClick(e) {

        var id = e.currentTarget.dataset.row_id;
        console.log("images: " + id);

        const image = this.state.images.filter(img => img.id == id);
        console.log("image: " , image[0]);

        this.setState({
            form: new FormData(),
            isImageEdit: true,
            dialogOpen: true,
            modalTitle: 'Editando imagen',
            imageID: image[0].id,
            imageOrder: image[0].order,
            image: '',
            imageDescription: image[0].alternativeText,
            defaultImage:image[0].url,
            
        })
    }

    render() {      

        return (
            <div>
                {this.renderHeaderTitle()}
                <Paper square>
                    <Tabs
                        value={this.state.tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                        aria-label="disabled tabs example"
                        scrollButtons="on"
                    >
                        <Tab label="Información general" value="0" />       
                        <Tab label="Imágenes" value="2" style={this.hideIfNewProduct()} />/> 
                    </Tabs>
                </Paper>
                
                {this.renderGeneralInformation()}

                {this.renderImageTab()}

                <Dialog open={this.state.dialogOpen} onClose={this.closeDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth='md'>
                    <DialogTitle id="form-dialog-title">{this.state.modalTitle}</DialogTitle>

                    <ValidatorForm ref="form"
                        onSubmit={this.onSubmitModal}
                        onError={errors => console.log(errors)}
                    >

                        <DialogContent>
                            <DialogContentText>
                            
                            </DialogContentText>         

                          

                            {
                                this.state.isImageEdit ?
                                      <Grid container spacing={2} >
                                <Grid item sm={6} xs={6}>
                                    <img src={this.state.defaultImage} style={{ width: '300px' }} />
                                </Grid>
                                <Grid item sm={6} xs={6}>
                                    <ImageUploader
                                        withPreview
                                        withIcon={false}
                                        buttonClassName="primary-color bg-base border-circle add-Button"
                                        buttonText="Seleccione una imágen"
                                        onChange={this.onDropImage}
                                        imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                        maxFileSize={5242880}
                                        label="Tamaño recomendado 600 x 600"
                                        singleImage={true}
                                        defaultImage={this.state.defaultImage}
                                    />
                                    <FormHelperText style={{ color: '#f44336' }}>{this.state.warningImageText}</FormHelperText>
                                </Grid>
                            </Grid>
                            :


                                    <Grid container spacing={2} >
                                      
                                        <Grid item sm={12} xs={12}>
                                            <ImageUploader
                                                withPreview
                                                withIcon={false}
                                                buttonClassName="primary-color bg-base border-circle add-Button"
                                                buttonText="Seleccione una imágen"
                                                onChange={this.onDropImage}
                                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                                maxFileSize={5242880}
                                                label="Tamaño recomendado 300 x 300"
                                                singleImage={true}
                                                defaultImage={this.state.defaultImage}
                                            />
                                            <FormHelperText style={{ color: '#f44336' }}>{this.state.warningImageText}</FormHelperText>
                                        </Grid>
                                    </Grid>

                            }

                        
                         

                     



                        </DialogContent>

                        <DialogActions>                                        

                            <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<SaveIcon />}
                            type="submit"

                        >
                            Guardar imagen
                        </Button>

                            <Button onClick={this.closeDialog} color="primary">
                            Cancelar
                        </Button>

                        </DialogActions>
                    </ValidatorForm>
                </Dialog>
            </div>
        )
    }
}


